import * as React from "react";
import { IdentityClaims, IdentityClaimsV2 } from "~/domain/tokens";

export type AuthenticationContextProps = {
  identity: IdentityClaims | null;
  identityV2: IdentityClaimsV2 | null;
  platformOptedInCookie: string | null;
  isVendrInternalEmployee: boolean;
  isSyntheticTest: boolean;
  isAuthenticatedWithVendrPlatform: boolean;
};

export const defaultAuthenticationContextProps: AuthenticationContextProps = {
  identity: null,
  identityV2: null,
  platformOptedInCookie: null,
  isVendrInternalEmployee: false,
  isSyntheticTest: false,
  isAuthenticatedWithVendrPlatform: false,
};

export const AuthenticationContext =
  React.createContext<AuthenticationContextProps>(
    defaultAuthenticationContextProps,
  );
